if ( typeof InfiniteScroll !== 'function' ) {

  class InfiniteScroll extends HTMLElement {

    constructor() {
      super();
      this._loading = false;
      this.button = this.querySelector('[data-infinite-more]');
      this.status = this.querySelector('[data-infinite-status]');

      if ( this.button ) {
        this.button.addEventListener('click', () => this.loadNext());
      }
    }

    connectedCallback() {
      // Pre-load slightly before the sentinel is visible so the grid never
      // visibly runs out of products while scrolling.
      if ( ! ('IntersectionObserver' in window) ) return;

      this._observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if ( entry.isIntersecting ) this.loadNext();
        });
      }, { rootMargin: '800px 0px' });

      this._observer.observe(this);
    }

    disconnectedCallback() {
      if ( this._observer ) this._observer.disconnect();
    }

    get nextUrl() {
      return this.getAttribute('data-next-url') || '';
    }

    loadNext() {
      if ( this._loading || ! this.nextUrl ) return;

      const url = this.nextUrl;
      const gridSelector = this.getAttribute('data-grid');
      const grid = document.querySelector(gridSelector);
      if ( ! grid ) return;

      this._loading = true;
      if ( this.button ) this.button.classList.add('working');

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fetchedGrid = doc.querySelector(gridSelector);
          if ( ! fetchedGrid ) {
            this._exhausted();
            return;
          }

          // Insert new cards before whatever wrapper holds this element,
          // so the "load more" area always stays at the end of the grid.
          let anchor = this;
          while ( anchor && anchor.parentElement !== grid ) {
            anchor = anchor.parentElement;
          }

          const items = fetchedGrid.querySelectorAll('[data-js-product-item]');
          items.forEach(item => {
            if ( anchor ) {
              grid.insertBefore(item, anchor);
            } else {
              grid.appendChild(item);
            }
          });

          const fetchedScroller = doc.querySelector('infinite-scroll');
          const next = fetchedScroller ? fetchedScroller.getAttribute('data-next-url') : '';

          if ( next ) {
            this.setAttribute('data-next-url', next);
          } else {
            this._exhausted();
          }

          if ( this.status ) {
            this.status.textContent = `${items.length}`;
          }

          // Keep the address bar on the last loaded page so a refresh or a
          // shared link lands close to where the shopper was.
          try {
            window.history.replaceState({}, '', url);
          } catch (e) {}

          if ( window.KROWN && KROWN.functions && KROWN.functions.eventDispatcher ) {
            KROWN.functions.eventDispatcher('krown:products:loaded', { count: items.length });
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this._loading = false;
          if ( this.button ) this.button.classList.remove('working');
        });
    }

    _exhausted() {
      this.removeAttribute('data-next-url');
      if ( this._observer ) this._observer.disconnect();
      if ( this.button ) this.button.hidden = true;
    }

  }

  if ( typeof customElements.get('infinite-scroll') == 'undefined' ) {
    customElements.define('infinite-scroll', InfiniteScroll);
  }

}
